/**
 * Whether a key press is meant for a field rather than a page shortcut. Takes the event or its target.
 * Without a selector: an input, textarea, select or editable element. With one: inside an element matching it.
 */
export function isTyping(e: Event | EventTarget | null, selector?: string): boolean {
  const t = (e instanceof Event ? e.target : e) as HTMLElement | null;
  if (selector !== undefined) return t instanceof Element && t.closest(selector) !== null;
  return Boolean(t && (t.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName)));
}
